import { createStore, is, StoreWritable } from 'effector';

export type Sourced<T> = T | StoreWritable<T>;

export const createSourced = <T>(value: Sourced<T>): StoreWritable<T> => {
	const $value = is.store(value) ? value : createStore<T>(value);

	return $value;
};
